import { inject, Injectable, linkedSignal } from '@angular/core';
import { UserStoreService } from '@user-store';
import { map, Observable, of } from 'rxjs';
import { AppSettings } from '../../../interfaces/app-settings.interface';

@Injectable({
	providedIn: 'root',
})
export class OnboardingService {
	userStore: UserStoreService<AppSettings> = inject(UserStoreService);

	onboardingWatched = linkedSignal(() => {
		return this.userStore.currentAppSettings().onboarding.analyticsWatched;
	});

	markOnboardingAsWatched(): Observable<AppSettings> {
		const currentSettings = this.userStore.currentAppSettings();
		if (currentSettings.onboarding.analyticsWatched) {
			return of(undefined);
		}
		const updatedSettings = {
			...currentSettings,
			onboarding: {
				...currentSettings.onboarding,
				analyticsWatched: true,
			},
		};
		return this.userStore.updateAppSettings(updatedSettings).pipe(map(() => updatedSettings));
	}
}
